import * as $ from 'jquery';

import * as Pikaday from 'pikaday-time';
import { PikadayOptions } from 'pikaday-time';

export default class EventPicker {
	private picker: Pikaday;

	constructor() {
		this.initEventPicker();
		$(document).on('jsfAjaxAlways', this.initEventPicker);
	}

	private initEventPicker = () => {
		this.picker = new Pikaday({
			field: document.getElementById('appointments\:eventDate'),
			showTime: false,
			format: 'MMM DD YYYY'
		});
	}
}
